import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  role: string;
  token: string;

  constructor(private _authService: AuthService, private _router: Router) {
    this.token = this._authService.getToken();
  }

  canActivate() {
    return this._authService.getProfile().pipe(
      map(res => {
        this.role = res.result.ROLE;
        if (this.token && (this.role === 'admin')) {
          return true;
        } else {
          this._router.navigate(['/']);
          return false;
        }
      }),
      catchError(() => {
        this._router.navigate(['/']);
        return of(false);
      })
    )
  }
  
  
}
